import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const [activeForm, setActiveForm] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentCategories, setCurrentCategories] = useState([]);
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });
  const [stats, setStats] = useState({
    customers: 0,
    products: 0,
    orders: 0,
    investors: 0
  });

  const allCategories = [
    { name: 'Accessories', icon: '👜', color: '#FF6B6B', gradient: 'linear-gradient(135deg, #FF6B6B, #FF8E8E)' },
    { name: 'Bags', icon: '🛍️', color: '#4ECDC4', gradient: 'linear-gradient(135deg, #4ECDC4, #72E6DC)' },
    { name: 'Beauty Cosmetics', icon: '💄', color: '#FF69B4', gradient: 'linear-gradient(135deg, #FF69B4, #FFB6C1)' },
    { name: 'Garmets', icon: '👗', color: '#9B59B6', gradient: 'linear-gradient(135deg, #9B59B6, #C39BD3)' },
    { name: 'Grocery', icon: '🛒', color: '#2ECC71', gradient: 'linear-gradient(135deg, #2ECC71, #58D68D)' },
    { name: 'IT', icon: '💻', color: '#3498DB', gradient: 'linear-gradient(135deg, #3498DB, #5DADE2)' },
    { name: 'Jewellery', icon: '💍', color: '#F39C12', gradient: 'linear-gradient(135deg, #F39C12, #F7C52F)' },
    { name: 'Mobile', icon: '📱', color: '#34495E', gradient: 'linear-gradient(135deg, #34495E, #5D6D7E)' },
    { name: 'Perfumes', icon: '🌸', color: '#E74C3C', gradient: 'linear-gradient(135deg, #E74C3C, #EC7063)' },
    { name: 'Stationary', icon: '📚', color: '#8E44AD', gradient: 'linear-gradient(135deg, #8E44AD, #A569BD)' },
    { name: 'Toys', icon: '🧸', color: '#E67E22', gradient: 'linear-gradient(135deg, #E67E22, #F8A55D)' },
    { name: 'Watches', icon: '⌚', color: '#16A085', gradient: 'linear-gradient(135deg, #16A085, #48C9B0)' },
    { name: 'Electronics', icon: '⚡', color: '#F1C40F', gradient: 'linear-gradient(135deg, #F1C40F, #F4D03F)' },
    { name: 'Home & Garden', icon: '🏡', color: '#27AE60', gradient: 'linear-gradient(135deg, #27AE60, #52C785)' },
    { name: 'Sports', icon: '⚽', color: '#E74C3C', gradient: 'linear-gradient(135deg, #E74C3C, #F1948A)' },
    { name: 'Books', icon: '📖', color: '#8E44AD', gradient: 'linear-gradient(135deg, #8E44AD, #BB8FCE)' }
  ];

  const countries = [
    { name: 'Indonesia', icon: '🏛️', active: false, code: 'id' },
    { name: 'Taiwan', icon: '🏯', active: false, code: 'tw' },
    { name: 'Vietnam', icon: '🏔️', active: false, code: 'vn' },
    { name: 'Thailand', icon: '🛕', active: false, code: 'th' },
    { name: 'Philippines', icon: '🏰', active: false, code: 'ph' },
    { name: 'Malaysia', icon: '🕌', active: false, code: 'my' },
    { name: 'Singapore', icon: '🏢', active: false, code: 'sg' },
    { name: 'Brazil', icon: '⛰️', active: false, code: 'br' },
    { name: 'Mexico', icon: '🏛️', active: false, code: 'mx' },
    { name: 'Colombia', icon: '⛪', active: false, code: 'co' },
    { name: 'Chile', icon: '🏛️', active: false, code: 'cl' },
    { name: 'United States', icon: '🗽', active: false, code: 'us' },
    { name: 'Canada', icon: '🍁', active: false, code: 'ca' },
    { name: 'United Kingdom', icon: '🏰', active: false, code: 'gb' },
    { name: 'Germany', icon: '🏰', active: false, code: 'de' },
    { name: 'France', icon: '🗼', active: false, code: 'fr' },
    { name: 'Australia', icon: '🦘', active: false, code: 'au' },
    { name: 'Japan', icon: '🏯', active: false, code: 'jp' },
    { name: 'South Korea', icon: '🏯', active: false, code: 'kr' },
    { name: 'Dubai (UAE)', icon: '🏗️', active: false, code: 'ae' },
    { name: 'Kuwait', icon: '🕌', active: false, code: 'kw' },
    { name: 'Saudi Arabia', icon: '🕌', active: false, code: 'sa' },
    { name: 'Qatar', icon: '🏙️', active: false, code: 'qa' },
    { name: 'Bahrain', icon: '🏛️', active: false, code: 'bh' },
    { name: 'Oman', icon: '🕌', active: false, code: 'om' },
    { name: 'Others', icon: '🌍', active: false, code: 'others' }
  ];

  const countryNames = countries.map(c => c.name);

  // Form configurations for all 9 forms
  const formConfigs = {
    vendor: {
      title: 'Join as Vendor',
      endpoint: 'https://dealnau.com/api/businesses/vendor',
      fields: [
        { name: 'businessName', label: 'Business Name', type: 'text', required: true },
        { name: 'personName', label: 'Person Name', type: 'text', required: true },
        { name: 'contactNumber', label: 'Contact Number', type: 'tel', required: true },
        { name: 'emailId', label: 'Email', type: 'email', required: true },
        { name: 'country', label: 'Country', type: 'select', required: true, options: countryNames },
        { name: 'businessCategory', label: 'Business Category', type: 'text', required: false },
        { name: 'yearsOld', label: 'Years in Business', type: 'number', required: false },
        { name: 'instagram', label: 'Instagram', type: 'text', required: false },
        { name: 'website', label: 'Website', type: 'url', required: false }
      ]
    },
    franchise: {
      title: 'Buy Franchise',
      endpoint: 'https://dealnau.com/api/businesses/franchise',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'mobile', label: 'Contact Number', type: 'tel', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'country', label: 'Country', type: 'select', required: true, options: countryNames },
        { name: 'city', label: 'City', type: 'text', required: true },
        { name: 'nationality', label: 'Nationality', type: 'text', required: true }
      ]
    },
    shareDetails: {
      title: 'Request Share Details',
      endpoint: 'https://dealnau.com/api/businesses/share-details',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'country', label: 'Country', type: 'select', required: true, options: countryNames },
        { name: 'mobile', label: 'Contact Number', type: 'tel', required: true }
      ]
    },
    influencer: {
      title: 'Join as Influencer',
      endpoint: 'https://dealnau.com/api/businesses/influencer',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'country', label: 'Country', type: 'select', required: true, options: countryNames },
        { name: 'mobile', label: 'Contact Number', type: 'tel', required: true }
      ]
    },
    driver: {
      title: 'Join as Driver',
      endpoint: 'https://dealnau.com/api/businesses/driver',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'country', label: 'Country', type: 'select', required: true, options: countryNames },
        { name: 'mobile', label: 'Contact Number', type: 'tel', required: true }
      ]
    },
    dataEntry: {
      title: 'Join as Data Entry Operator',
      endpoint: 'https://dealnau.com/api/businesses/data-entry',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'country', label: 'Country', type: 'select', required: true, options: countryNames },
        { name: 'mobile', label: 'Contact Number', type: 'tel', required: true }
      ]
    },
    entrepreneur: {
      title: 'Join as Entrepreneur',
      endpoint: 'https://dealnau.com/api/businesses/entrepreneur',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'expertise', label: 'Expertise', type: 'text', required: true }
      ]
    },
    question: {
      title: 'Ask Questions',
      endpoint: 'https://dealnau.com/api/businesses/question',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'number', label: 'Contact Number', type: 'tel', required: true },
        { name: 'question', label: 'Question', type: 'textarea', required: true }
      ]
    },
    volunteer: {
      title: 'Go Green Volunteer',
      endpoint: 'https://dealnau.com/api/businesses/volunteer',
      fields: [
        { name: 'name', label: 'Name', type: 'text', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'country', label: 'Country', type: 'select', required: true, options: countryNames },
        { name: 'mobile', label: 'Contact Number', type: 'tel', required: true }
      ]
    }
  };

  // Function to shuffle and get random categories
  const getRandomCategories = () => {
    const shuffled = [...allCategories].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 12);
  };

  useEffect(() => {
    setIsLoaded(true);
    setCurrentCategories(getRandomCategories());
    fetchStats();
    
    // Switch categories every 4 seconds
    const interval = setInterval(() => {
      setCurrentCategories(getRandomCategories());
    }, 4000);
    
    return () => clearInterval(interval);
  }, []);

  const fetchStats = async () => {
    try {
      const response = await fetch('https://dealnau.com/api/businesses/stats');
      const result = await response.json();
      if (result.success) {
        setStats(result.stats);
      }
    } catch (error) {
      console.error('Failed to fetch stats:', error);
      // Set default values if fetch fails
      setStats({
        customers: 1250,
        products: 5400,
        orders: 8900,
        investors: 150
      });
    }
  };

  const openForm = (formType) => {
    setActiveForm(formType);
    setFormData({});
    setSubmitMessage({ type: '', text: '' });
  };

  const closeForm = () => {
    setActiveForm(null);
    setFormData({});
    setSubmitMessage({ type: '', text: '' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage({ type: '', text: '' });

    try {
      const config = formConfigs[activeForm];
      const response = await fetch(config.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        setSubmitMessage({ 
          type: 'success', 
          text: '✅ Submitted successfully! We will contact you soon.' 
        });
        setFormData({});
        fetchStats(); // Refresh stats after submission
        setTimeout(() => closeForm(), 3000);
      } else {
        setSubmitMessage({ 
          type: 'error', 
          text: '❌ ' + (result.message || 'Submission failed. Please try again.') 
        });
      }
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitMessage({ 
        type: 'error', 
        text: '❌ Network error. Please check your connection and try again.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderFormField = (field) => {
    if (field.type === 'select') {
      return (
        <select
          name={field.name}
          value={formData[field.name] || ''}
          onChange={handleInputChange}
          required={field.required}
          className="form-input"
        >
          <option value="">Select {field.label}</option>
          {field.options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      );
    } else if (field.type === 'textarea') {
      return (
        <textarea
          name={field.name}
          placeholder={field.label}
          value={formData[field.name] || ''}
          onChange={handleInputChange}
          required={field.required}
          className="form-input"
          rows="4"
        />
      );
    } else {
      return (
        <input
          type={field.type}
          name={field.name}
          placeholder={field.label}
          value={formData[field.name] || ''}
          onChange={handleInputChange}
          required={field.required}
          className="form-input"
        />
      );
    }
  };

  const handleCountryClick = (country) => {
    if (country.active) {
      alert(`Welcome to DealNau ${country.name}!`);
    }
  };

  return (
    <div className={`App ${isLoaded ? 'loaded' : ''}`}>
      {/* Navbar */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-left">
            <div className="logo">
              <h2>DealNau</h2>
              <span className="tagline">Your Global Marketplace</span>
            </div>
            <div className="nav-buttons">
              <button className="nav-btn disabled">Download App</button>
              <button className="nav-btn disabled">Login</button>
            </div>
          </div>
          <button className="join-btn" onClick={() => openForm('vendor')}>
            Join as Vendor
          </button>
        </div>
      </nav>

      {/* Banner Section */}
      <section className="banner">
        <div className="banner-container">
          <div className="banner-left fade-in-left">
            <h1>DealNau Marketplace</h1>
            <p>Connect with millions of buyers and sellers worldwide. DealNau provides a seamless, secure, and reliable e-commerce platform for businesses of all sizes.</p>
            
            <div className="banner-features">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Secure Payments</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Global Reach</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>24/7 Support</span>
              </div>
            </div>
            
            <button className="start-investing-btn button-hover" onClick={() => openForm('vendor')}>
              Start Selling Now
            </button>
          </div>
          
          <div className="banner-right fade-in-right">
            <div className="categories-header">
              <h3>Discover thousands of products</h3>
              <p>across various categories</p>
            </div>
            <div className="categories-grid">
              {currentCategories.map((category, index) => (
                <div 
                  key={index} 
                  className="category-card category-fade card-hover" 
                  style={{ 
                    '--category-gradient': category.gradient,
                    animationDelay: `${index * 0.1}s`
                  }}
                >
                  <div className="category-overlay"></div>
                  <div className="category-icon-wrapper">
                    <div className="category-icon">{category.icon}</div>
                  </div>
                  <div className="category-name">{category.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Country Selection */}
      <section className="country-selection">
        <div className="container">
          <h2>DealNau Going Global</h2>
          <p>Expanding to multiple countries worldwide</p>
          <p className="choose-text">Choose a country or region.</p>
          
          <div className="countries-grid">
            {countries.map((country, index) => (
              <div 
                key={country.code}
                className={`country-card ${country.active ? 'active' : 'disabled'}`}
                onClick={() => handleCountryClick(country)}
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <div className="country-icon-wrapper">
                  <div className="country-icon">{country.icon}</div>
                </div>
                <div className="country-name">{country.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Counter Section */}
      {/* <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-number">{stats.customers.toLocaleString()}</div>
              <div className="stat-label">Customers</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📦</div>
              <div className="stat-number">{stats.products.toLocaleString()}</div>
              <div className="stat-label">Products</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🛍️</div>
              <div className="stat-number">{stats.orders.toLocaleString()}</div>
              <div className="stat-label">Orders</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💼</div>
              <div className="stat-number">{stats.investors.toLocaleString()}</div>
              <div className="stat-label">Investors</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Join Ecosystem Section with All Buttons */}
      <section className="cta-section">
        <div className="container">
          <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '2rem', color: '#333' }}>
            Join Our Ecosystem
          </h2>
          <p style={{ textAlign: 'center', fontSize: '1.2rem', marginBottom: '3rem', color: '#666' }}>
            DealNau offers a seamless, fun and reliable shopping experience to millions of users worldwide.
          </p>
          <div className="cta-grid">
            <button className="cta-button button-hover" onClick={() => openForm('vendor')}>
              <span className="cta-icon">🏪</span>
              <span className="cta-text">Join as Vendor</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('franchise')}>
              <span className="cta-icon">🏢</span>
              <span className="cta-text">Buy Franchise</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('shareDetails')}>
              <span className="cta-icon">📊</span>
              <span className="cta-text">Request Share Details</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('influencer')}>
              <span className="cta-icon">✨</span>
              <span className="cta-text">Join as Influencer</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('driver')}>
              <span className="cta-icon">🚗</span>
              <span className="cta-text">Join as Driver</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('dataEntry')}>
              <span className="cta-icon">💼</span>
              <span className="cta-text">Join as Data Entry Operator</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('entrepreneur')}>
              <span className="cta-icon">🚀</span>
              <span className="cta-text">Join as Entrepreneur</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('question')}>
              <span className="cta-icon">❓</span>
              <span className="cta-text">Ask Questions</span>
            </button>
            <button className="cta-button button-hover" onClick={() => openForm('volunteer')}>
              <span className="cta-icon">🌱</span>
              <span className="cta-text">Go Green Volunteer</span>
            </button>
          </div>
        </div>
      </section>


      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>DealNau</h3>
              <p>Your trusted global marketplace connecting buyers and sellers worldwide.</p>
              {/* <div className="social-links">
                <div className="social-link">📘</div>
                <div className="social-link">📷</div>
                <div className="social-link">🐦</div>
                <div className="social-link">💼</div>
              </div> */}
            </div>
            
            {/* <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><span className="footer-item">About Us</span></li>
                <li><span className="footer-item">Careers</span></li>
                <li><span className="footer-item">Press</span></li>
                <li><span className="footer-item">Blog</span></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                <li><span className="footer-item">Help Center</span></li>
                <li><span className="footer-item">Safety Center</span></li>
                <li><span className="footer-item">Guidelines</span></li>
                <li><span className="footer-item">Contact</span></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Legal</h4>
              <ul>
                <li><span className="footer-item">Privacy Policy</span></li>
                <li><span className="footer-item">Terms of Service</span></li>
                <li><span className="footer-item">Cookie Policy</span></li>
                <li><span className="footer-item">Licenses</span></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Download</h4>
              <ul>
                <li><span className="footer-item">iOS App</span></li>
                <li><span className="footer-item">Android App</span></li>
                <li><span className="footer-item">Desktop App</span></li>
              </ul>
            </div>*/}
          </div> 
          
          <div className="footer-bottom">
            <p>© 2025 DealNau. All rights reserved.</p>
            <div className="footer-badges">
              <span className="badge">🔒 Secure</span>
              <span className="badge">✓ Verified</span>
              <span className="badge">🌍 Global</span>
            </div>
          </div>
        </div>
      </footer>

      {/* Universal Modal Form */}
      {activeForm && (
        <div className="modal-overlay modal-fade-in" onClick={closeForm}>
          <div className="modal-content modal-slide-up" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close hover-rotate" onClick={closeForm}>×</button>
            <h2 className="modal-title">{formConfigs[activeForm].title}</h2>
            
            {submitMessage.text && (
              <div className={`submit-message ${submitMessage.type}`}>
                {submitMessage.text}
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="registration-form">
              {formConfigs[activeForm].fields.map((field, index) => (
                <div key={index} className="form-group">
                  <label className="form-label">
                    {field.label} {field.required && <span style={{ color: '#ff6b6b' }}>*</span>}
                  </label>
                  {renderFormField(field)}
                </div>
              ))}
              
              <button 
                type="submit" 
                className="submit-button" 
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
